'use strict';

var toastr = require('toastr');
toastr.options.preventDuplicates = true;
var BootstrapConfig = function BootstrapConfig(RestangularProvider, $qProvider) {
  $qProvider.errorOnUnhandledRejections(false);
  RestangularProvider.setBaseUrl('/api');
  RestangularProvider.setErrorInterceptor(function (response) {
    if (response.status === 401) {
      toastr.error('Unauthorized - Error 401');
    } else if (response.status === 413) {
      toastr.error('Too much data requested. Please narrow your search.');
    } else if (response.status === 412) {
      // Precondition Failed - don't display the error, the user will be able to select a carrier to proceed
    } else if (response.status === 409) {
      // 409 errors are being handled in each case in a specific way
    } else if (response.status === 400) {
      toastr.error(response.statusText + ' - Invalid request data sent.');
    } else if (response.status !== 404) {
      toastr.error(response.statusText + ' - Error ' + response.status + ' An unknown error has occurred.');
    }
    return true;
  });
};
BootstrapConfig.$inject = ['RestangularProvider', '$qProvider'];
module.exports = BootstrapConfig;